import styled from 'styled-components';


const Root = styled.header`
	position: relative;
	width: 100%;
	height: 70px;
	background-color: #fff;
	height: auto;
	box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.08);
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
`;

const ContentLayout = styled.div`
	flex: 1 1 auto;
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-end;
	align-items: center;
`;

export {
	Root,
	ContentLayout,
};
